import React from 'react'
import { Box, Heading } from '@chakra-ui/react'

type Props = {
    title: string
    children: React.ReactNode
}

export const Subsection = ({ title, children }: Props) => {
    return (
        <Box>
            <Heading size="md" mb={3}>
                {title}
            </Heading>

            {children}
        </Box>
    )
}
